import React from 'react';
import { bonuses, OFFER_ANCHOR } from '../data/product';
export function BonusSection() {
  return <section className="bg-navy2 px-4 py-4 sm:py-6" data-id="element-19" data-mp="1ogn8frff7v70">
      <div className="mx-auto max-w-4xl" data-id="element-20" data-mp="1ohybfp11kyx2">
        <h2 className="text-center text-lg leading-tight text-white sm:text-3xl" data-id="element-21" data-mp="22fwp0s7jgrbi">
          🎁 5 PROFESSIONAL BONUSES INCLUDED
        </h2>

        <div className="mt-2 grid gap-1.5 sm:grid-cols-2" data-id="element-22" data-mp="1yet8s4lkwt9r">
          {bonuses.map(bonus => <a key={bonus.num} href={OFFER_ANCHOR} className="flex flex-col rounded-md border border-volt/40 bg-white/[0.05] p-2.5 transition-colors duration-150 hover:border-volt" data-id="element-23" data-mp="1aop6q1o1h1kv">
              <p className="font-head text-[12px] font-bold uppercase tracking-wide text-volt" data-id="element-24" data-mp="1eqar082wki53">
                🎁 BONUS {bonus.num}
              </p>
              <h3 className="mt-0.5 text-[15px] leading-tight text-white sm:text-lg" data-id="element-25" data-mp="qywxhyt0mgij">
                {bonus.title}
              </h3>
              <p className="mt-0.5 font-head text-[13px] font-bold uppercase tracking-wide text-white/90" data-id="element-26" data-mp="mx1ves39fz3p">
                {bonus.count}
              </p>
              <p className="mt-1 text-[13px] font-medium leading-snug text-white/80" data-id="element-27" data-mp="2epv3cy338lri">
                {bonus.body}
              </p>
              <p className="mt-auto pt-1.5 font-head text-[13px] font-bold uppercase tracking-wide text-volt" data-id="element-28" data-mp="2jjz9xg8fyrs2">
                {bonus.kicker}
              </p>
            </a>)}
        </div>
      </div>
    </section>;
}